import { Instagram, FormatBold, YouTube } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { DEVICES } from '../const';


const Background = styled.div`
  background: #000;
  width: 100%;
  display: flex;
  @media ${DEVICES.mobile} {
    height: 200px;
    flex-direction: column;
    justify-content: start;
  }

  @media ${DEVICES.tablet} {
    height: 150px;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }

  @media ${DEVICES.large} {
    height: 200px;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  } 
`;

const Left = styled.div`
  color: white;
  text-align: center;
  line-height: 1.5rem;
  @media ${DEVICES.mobile} {
    margin-top: 50px;
  }
  @media ${DEVICES.tablet} {
    margin-top: 0px;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;


export default function Footer() {
  return <Background>
    <Left>
      Copyright Ⓒ 2023 캥거루짐 <br />
      Powered by 캥거루짐
    </Left>
    <Right>
      <IconButton href='https://www.instagram.com/kangaroo.sports' size='large'>
        <Instagram style={{ color: '#ffffff', width: '40px', height: '40px' }} />
      </IconButton>
      <IconButton href='https://blog.naver.com/kangaroo_sports' size='large'>
        <FormatBold style={{ color: '#ffffff', width: '40px', height: '40px' }} />
      </IconButton>
      <IconButton href='https://www.youtube.com/@kangaroogym' size='large'>
        <YouTube style={{ color: '#ffffff', width: '40px', height: '40px' }} />
      </IconButton>
    </Right>
  </Background >
}
